import { Address } from '@vfde-sails/avc-core';
import { LmForm } from '../interface';
import { StringMap } from '../../../interface';
import { LmFormDTO } from '@vfde-sails/avc-core';
import { Title } from '../enum';

/**
 * isTitleValid
 */
export const isTitleValid = (title?: string): title is Title => Object.values(Title).includes(title as Title);

/**
 * getStringProps
 */
export const getStringProps = (props: object): StringMap => {
    const stringProps: StringMap = {};

    for (const [key, value] of Object.entries(props)) {
        if (!value) {
            throw Error(`The following required property is not valid: '${key}', value: '${value}'`);
        }

        stringProps[key] = value.toString();
    }

    return stringProps;
};

/**
 * @example '2000-01-01 01:01:01'
 */
const getTimeStamp = () => new Date()
    .toISOString()
    .replace('T', ' ')
    .split('.')[0];

/**
 * Constructs LM Payload for submit
 *
 * @param lmsFormData - Form data filled by user
 * @param address - User's address
 */
export const getLmPayload = (lmsFormData: LmForm, address: Address): LmFormDTO => {
    const { firstName, lastName, email, salutation } = lmsFormData;

    const {
        city, street, housenumber, zipcode,
        housenumberextra, district,
    } = address;

    const requiredProps = getStringProps({
        firstName,
        lastName,
        email,
        city,
        street,
        housenumber,
        district,
        zipcode,
    });

    return {
        salutation: isTitleValid(salutation) ? salutation : '',
        timestamp: getTimeStamp(),
        firstName: requiredProps.firstName,
        lastName: requiredProps.lastName,
        email: requiredProps.email,
        city: requiredProps.city,
        street: requiredProps.street,
        houseNumber: requiredProps.housenumber,
        houseNumberExtra: housenumberextra ? housenumberextra : null,
        district: requiredProps.district,
        zipcode: requiredProps.zipcode,
        referrer: window.location.host,
    };
};
